module.exports = function getResource(label, vars = []) {
    let resources = {
        freeShipping: 'You now qualify for free shipping!',
        rougeFreeShipping: 'As a Rouge, you get FREE FLASH SHIPPING on every order',
        rowFreeShipping: 'ROW free shipping',
        freeFlashShipping: 'Enjoy FREE FLASH SHIPPING on every order',
        alreadySubscribedToFlash: 'You are already subscribed to Flash. This item will be removed from your basket.',
        rougeEnrolledForFree: 'Rouge, visit the Flash page to enroll for FREE. This item will be removed from your basket.'
    };

    return resources[label];
};
